import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import ourPeopleData from '../../../constants/team/our-people';
import TeamGrid from './TeamGrid';
import { STACK_CENTER_COLUMN_DIRECTION } from '../../../constants/mui-components';

const TeamSection = ({ people }) => {
  const theme = useTheme();

  return (
    <Stack
      id="team-section"
      className={STACK_CENTER_COLUMN_DIRECTION}
      sx={{ gap: '3rem', padding: { xs: '2.5rem 0 1rem 0', ipad: '2.5rem 0 2rem 0' }, width: '100%' }}
    >
      <Stack
        className={STACK_CENTER_COLUMN_DIRECTION}
        sx={{ alignSelf: 'stretch', gap: '1rem' }}
      >
        <Typography
          variant="title_2"
          color={theme.palette.common.white}
          fontSize={{ xs: '2rem', ipad: '3rem' }}
          textAlign="center"
        >
          {ourPeopleData.titlePart1}
          <Typography
            component="span"
            variant="title_2"
            fontFamily="Playfair Display"
            fontStyle="italic"
            color={theme.palette.common.white}
            marginLeft="0.8rem"
            fontSize={{ xs: '2rem', ipad: '3rem' }}
            sx={{ display: 'inline' }}
          >
            {ourPeopleData.titlePart2}
          </Typography>
        </Typography>
        <Typography
          variant="medium_1"
          fontWeight={400}
          color={theme.palette.neutral.A300}
          textAlign="center"
        >
          {ourPeopleData.description}
        </Typography>
      </Stack>
      <TeamGrid people={people} />
    </Stack>
  );
};

TeamSection.propTypes = {
  people: PropTypes.arrayOf(PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    position: PropTypes.string.isRequired,
    picture: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
};

export default TeamSection;
